module.exports = __webpack_public_path__ + "static/media/Gochittand-01.f163b34d.svg";